exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".video-list {\n  background: rgba(255, 255, 255, 0.2);\n  border-left: 1px solid white;\n  height: 100%;\n  box-shadow: inset 0 2px 6px rgba(0, 0, 0, 0.6); }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/components/VideoList.scss
// module id = 458
// module chunks = 0